import { isApolloError } from '@apollo/client';
import type { ServerError } from '@apollo/client';

/**
 * L'API n'a pas répondu (Failed to fetch, Load failed, 5xx sans corps GraphQL). Une requête refusée en 400 arrive
 * elle aussi en `networkError`, mais avec ses erreurs GraphQL dans le corps : c'est une erreur de contrat.
 */
export function isNetworkFailure(error: unknown): boolean {
    if (!(error instanceof Error) || !isApolloError(error) || !error.networkError || error.graphQLErrors.length) {
        return false;
    }

    const result = (error.networkError as Partial<ServerError>).result;
    return !(result && typeof result === 'object' && Array.isArray(result.errors));
}
